import Vue from 'vue';
import ElementUI from 'element-ui';
import MuseUI from 'muse-ui';
import axios from 'axios';
import VueAxios from 'vue-axios'
import VueI18n from 'vue-i18n';
import VueBarcode from 'vue-barcode';
import App from './App.vue'
import router from './router';
import store from '../src/module/index';
import './assets/application.js';
import Ch from './assets/translate/Ch';
import En from './assets/translate/En';
// ---
import 'element-ui/lib/theme-chalk/index.css';
import 'muse-ui/dist/muse-ui.css';
import 'material-design-icons/iconfont/material-icons.css';


Vue.config.productionTip = false;


Vue.use(MuseUI);
Vue.use(ElementUI);
Vue.use(VueBarcode);
Vue.use(VueI18n);
Vue.use(VueAxios, axios);


const i18n = new VueI18n({
  locale: 'zh',
  messages: {
    zh: Ch,
    en: En,
  },
});

new Vue({
  render: h => h(App),
  router,
  i18n,
  store,
}).$mount('#app')
